<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.daily_summary_company") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-12
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getStatement(true)"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="statementList.length > 0" mode="DailySummaryCompany" tbl="tblList" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading").mr-2
                dailySummaryCompanyExport(v-if="statementList.length > 0" :tbl="statementList" :totalTbl="grandTotalList" tblId="tblList")
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12(style="max-height: 70vh; overflow: hidden;")
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th.sortable(width="12%" @click="sortOrder('working_date')")
                          span(:title="$t('ui.working_date')") {{ $t('ui.short.working_date') }}
                          .float-right
                            i(:class="changeSortKey('working_date')")
                        th.text-right(width="11%")
                          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.valid_turnover')") {{ $t('ui.short.valid_turnover') }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.deposit_amount')") {{ $t('ui.short.deposit_amount') }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.deposit_count')") {{ $t('ui.short.deposit_count') }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.short.withdrawal_amount") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.withdrawal_count')") {{ $t("ui.short.withdrawal_count") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.bonus_amount')") {{ $t("ui.short.bonus_amount") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.adjustment_amount')") {{ $t("ui.short.adjustment_amount") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.referee_count')") {{ $t("ui.short.referee_count") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.signup_count')") {{ $t("ui.short.signup_count") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.verified_count')") {{ $t("ui.short.verified_count") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.active_member')") {{ $t("ui.short.active_member") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.ftd_count')") {{ $t("ui.short.ftd_count") }}
                        th.text-right(width="11%")
                          span(:title="$t('ui.ftd_amount')") {{ $t("ui.short.ftd_amount") }}
                        //- th.text-right(width="11%")
                        //-   span(:title="$t('ui.unique_login_count')") {{ $t("ui.short.unique_login_count") }}
                        //- th.text-right(width="11%")
                        //-   span(:title="$t('ui.unique_withdrawal_count')") {{ $t("ui.short.unique_withdrawal_count") }}
                        //- th.text-right(width="11%")
                        //-   span(:title="$t('ui.second_deposit_count')") {{ $t("ui.short.second_deposit_count") }}
                    tbody.clusterize-content
                      tr(v-if="statementList.length == 0")
                        td(colspan="19").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in statementList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                        td.text-right
                          //- span.font-weight-bold(v-if="item.winlose == 0" :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                          //- span.font-weight-bold(v-if="item.winlose != 0")
                          //-   b-link(href="javascript:void(0);" @click="redirectToDSM(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                          //- TEMP HIDE
                          //- span.font-weight-bold(v-if="item.winlose != 0 && showActionButton('dailysummarymember')")
                          //-   b-link(href="javascript:void(0);" @click="redirectToDSM(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                          //- span.font-weight-bold(v-else :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.deposit_count, 'integer')") {{ $n(item.deposit_count, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.withdrawal_count, 'integer')") {{ $n(item.withdrawal_count, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="[item.bonus_amount < 0 ? 'text-danger' : '']" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="[item.adjustment_amount < 0 ? 'text-danger' : '']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.referee_count, 'integer')") {{ $n(item.referee_count, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.signup_count, 'integer')") {{ $n(item.signup_count, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.verified_count, 'integer')") {{ $n(item.verified_count, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.active_member, 'integer')") {{ $n(item.active_member, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:title="$n(item.ftd_count, 'integer')") {{ $n(item.ftd_count, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.ftd_amount)" :title="$n(item.ftd_amount, 'currency')") {{ $n(item.ftd_amount, 'currency') }}
                        //- td.text-right
                        //-   span.font-weight-bold
                        //-     b-link(href="javascript:void(0);" @click="redirectToUniqueLogin(item)" :class="[item.unique_login_count < 0 ? 'text-danger' : 'text-info']" :title="$n(item.unique_login_count, 'integer')") {{ $n(item.unique_login_count, 'integer') }}
                        //- td.text-right
                        //-   span.font-weight-bold
                        //-     b-link(href="javascript:void(0);" @click="redirectToUniqueWithdrawal(item)" :class="[item.unique_withdrawal_count < 0 ? 'text-danger' : 'text-info']" :title="$n(item.unique_withdrawal_count, 'integer')") {{ $n(item.unique_withdrawal_count, 'integer') }}
                        //- td.text-right
                        //-   span.font-weight-bold
                        //-     b-link(href="javascript:void(0);" @click="redirectToSecondDeposit(item)" :class="[item.second_deposit_count < 0 ? 'text-danger' : 'text-info']" :title="$n(item.second_deposit_count, 'integer')") {{ $n(item.second_deposit_count, 'integer') }}
                      tr(v-if="showTotal")
                        td.text-right(colspan="2")
                          span {{ $t("ui.sub_total") }}
                          br
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmount)" :title="$n(subTotalDepositAmount, 'currency')") {{ $n(subTotalDepositAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmount)" :title="$n(grandTotalDepositAmount, 'currency')") {{ $n(grandTotalDepositAmount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositCount)" :title="$n(subTotalDepositCount, 'integer')") {{ $n(subTotalDepositCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCount)" :title="$n(grandTotalDepositCount, 'integer')") {{ $n(grandTotalDepositCount, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="[subTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="[grandTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWithdrawalCount)" :title="$n(subTotalWithdrawalCount, 'integer')") {{ $n(subTotalWithdrawalCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalCount)" :title="$n(grandTotalWithdrawalCount, 'integer')") {{ $n(grandTotalWithdrawalCount, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmount)" :title="$n(subTotalBonusAmount, 'currency')") {{ $n(subTotalBonusAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmount)" :title="$n(grandTotalBonusAmount, 'currency')") {{ $n(grandTotalBonusAmount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalAdjustmentAmount)" :title="$n(subTotalAdjustmentAmount, 'currency')") {{ $n(subTotalAdjustmentAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmount)" :title="$n(grandTotalAdjustmentAmount, 'currency')") {{ $n(grandTotalAdjustmentAmount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalRefereeCount)" :title="$n(subTotalRefereeCount, 'integer')") {{ $n(subTotalRefereeCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRefereeCount)" :title="$n(grandTotalRefereeCount, 'integer')") {{ $n(grandTotalRefereeCount, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalSignupCount)" :title="$n(subTotalSignupCount, 'integer')") {{ $n(subTotalSignupCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalSignupCount)" :title="$n(grandTotalSignupCount, 'integer')") {{ $n(grandTotalSignupCount, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalVerifiedCount)" :title="$n(subTotalVerifiedCount, 'integer')") {{ $n(subTotalVerifiedCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalVerifiedCount)" :title="$n(grandTotalVerifiedCount, 'integer')") {{ $n(grandTotalVerifiedCount, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalActiveMember)" :title="$n(subTotalActiveMember, 'integer')") {{ $n(subTotalActiveMember, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActiveMember)" :title="$n(grandTotalActiveMember, 'integer')") {{ $n(grandTotalActiveMember, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalFtdCount)" :title="$n(subTotalFtdCount, 'integer')") {{ $n(subTotalFtdCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalFtdCount)" :title="$n(grandTotalFtdCount, 'integer')") {{ $n(grandTotalFtdCount, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalFtdAmount)" :title="$n(subTotalFtdAmount, 'currency')") {{ $n(subTotalFtdAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalFtdAmount)" :title="$n(grandTotalFtdAmount, 'currency')") {{ $n(grandTotalFtdAmount, 'currency') }}
                        //- td.text-right
                        //-   span.font-weight-bold(:class="$helpers.fontClassName(subTotalUniqueLoginCount)" :title="$n(subTotalUniqueLoginCount, 'integer')") {{ $n(subTotalUniqueLoginCount, 'integer') }}
                        //-   br
                        //-   span.font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueLoginCount)" :title="$n(grandTotalUniqueLoginCount, 'integer')") {{ $n(grandTotalUniqueLoginCount, 'integer') }}
                        //- td.text-right
                        //-   span.font-weight-bold(:class="$helpers.fontClassName(subTotalUniqueWithdrawalCount)" :title="$n(subTotalUniqueWithdrawalCount, 'integer')") {{ $n(subTotalUniqueWithdrawalCount, 'integer') }}
                        //-   br
                        //-   span.font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueWithdrawalCount)" :title="$n(grandTotalUniqueWithdrawalCount, 'integer')") {{ $n(grandTotalUniqueWithdrawalCount, 'integer') }}
                        //- td.text-right
                        //-   span.font-weight-bold(:class="$helpers.fontClassName(subTotalSecondDepositCount)" :title="$n(subTotalSecondDepositCount, 'integer')") {{ $n(subTotalSecondDepositCount, 'integer') }}
                        //-   br
                        //-   span.font-weight-bold(:class="$helpers.fontClassName(grandTotalSecondDepositCount)" :title="$n(grandTotalSecondDepositCount, 'integer')") {{ $n(grandTotalSecondDepositCount, 'integer') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import dailySummaryCompanyExport from "@/components/report/dailySummaryCompanyExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    dailySummaryCompanyExport
  },
  data: () => ({
    loading: false,
    grandTotalList: [],
    statementList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalDepositAmount: 0,
    grandTotalDepositAmount: 0,
    subTotalDepositCount: 0,
    grandTotalDepositCount: 0,
    subTotalWithdrawalAmount: 0,
    grandTotalWithdrawalAmount: 0,
    subTotalWithdrawalCount: 0,
    grandTotalWithdrawalCount: 0,
    subTotalBonusAmount: 0,
    grandTotalBonusAmount: 0,
    subTotalAdjustmentAmount: 0,
    grandTotalAdjustmentAmount: 0,
    subTotalRefereeCount: 0,
    grandTotalRefereeCount: 0,
    subTotalSignupCount: 0,
    grandTotalSignupCount: 0,
    subTotalVerifiedCount: 0,
    grandTotalVerifiedCount: 0,
    subTotalActiveMember: 0,
    grandTotalActiveMember: 0,
    subTotalFtdCount: 0,
    grandTotalFtdCount: 0,
    subTotalFtdAmount: 0,
    grandTotalFtdAmount: 0,
    subTotalUniqueLoginCount: 0,
    grandTotalUniqueLoginCount: 0,
    subTotalUniqueWithdrawalCount: 0,
    grandTotalUniqueWithdrawalCount: 0,
    subTotalSecondDepositCount: 0,
    grandTotalSecondDepositCount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "working_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
        this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
        this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getStatement(true);
    }
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    redirectToUniqueLogin: function(item) {
      var json = {
        working_date: item.working_date
      };

      this.$store.dispatch("user/setDailySummaryCompanyDetailParam", json);
      this.$router.push("/report/uniqueLogin");
    },
    redirectToUniqueWithdrawal: function(item) {
      var json = {
        working_date: item.working_date
      };

      this.$store.dispatch("user/setDailySummaryCompanyDetailParam", json);
      this.$router.push("/report/uniqueWithdrawal");
    },
    redirectToSecondDeposit: function(item) {
      var json = {
        working_date: item.working_date
      };

      this.$store.dispatch("user/setDailySummaryCompanyDetailParam", json);
      this.$router.push("/report/secondDeposit");
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getStatement(true);
    },
    setReportStatementParam() {
      var json = {
        operator_id: this.$store.getters.reportStatement.operator_id,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.$store.dispatch("user/setReportStatementParam", json);
    },
    redirectToDSM: function(item) {
        var json = {
          working_date: item.working_date
        };
        this.$store.dispatch("user/setDailySummaryMemberParam", json);
        this.$router.push("/report/dailySummaryMember");
    },
    getStatement: function(isSearch) {
      if (this.checkDateRange()) {

        this.setReportStatementParam();

        let url = config.dailySummaryCompanyUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.statement.length > 0) {
                    this.showTotal = true;
                    response.data.ds.statement.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalDepositAmount = parseFloat(this.subTotalDepositAmount) + parseFloat(value["deposit_amount"]);
                      this.subTotalDepositCount = parseInt(this.subTotalDepositCount) + parseInt(value["deposit_count"]);
                      this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"]);
                      this.subTotalWithdrawalCount = parseInt(this.subTotalWithdrawalCount) + parseInt(value["withdrawal_count"]);
                      this.subTotalBonusAmount = parseFloat(this.subTotalBonusAmount) + parseFloat(value["bonus_amount"]);
                      this.subTotalAdjustmentAmount = parseFloat(this.subTotalAdjustmentAmount) + parseFloat(value["adjustment_amount"]);
                      this.subTotalRefereeCount = parseInt(this.subTotalRefereeCount) + parseInt(value["referee_count"]);
                      this.subTotalSignupCount = parseInt(this.subTotalSignupCount) + parseInt(value["signup_count"]);
                      this.subTotalVerifiedCount = parseInt(this.subTotalVerifiedCount) + parseInt(value["verified_count"]);
                      this.subTotalActiveMember = parseInt(this.subTotalActiveMember) + parseInt(value["active_member"]);
                      this.subTotalFtdCount = parseInt(this.subTotalFtdCount) + parseInt(value["ftd_count"]);
                      this.subTotalFtdAmount = parseFloat(this.subTotalFtdAmount) + parseFloat(value["ftd_amount"]);
                      this.subTotalUniqueLoginCount = parseInt(this.subTotalUniqueLoginCount) + parseInt(value["unique_login_count"]);
                      this.subTotalUniqueWithdrawalCount = parseInt(this.subTotalUniqueWithdrawalCount) + parseInt(value["unique_withdrawal_count"]);
                      this.subTotalSecondDepositCount = parseInt(this.subTotalSecondDepositCount) + parseInt(value["second_deposit_count"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalDepositAmount = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalDepositCount = response.data.ds.grand_total[0]["deposit_count"];
                      this.grandTotalWithdrawalAmount = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalWithdrawalCount = response.data.ds.grand_total[0]["withdrawal_count"];
                      this.grandTotalBonusAmount = response.data.ds.grand_total[0]["bonus_amount"];
                      this.grandTotalAdjustmentAmount = response.data.ds.grand_total[0]["adjustment_amount"];
                      this.grandTotalRefereeCount = response.data.ds.grand_total[0]["referee_count"];
                      this.grandTotalSignupCount = response.data.ds.grand_total[0]["signup_count"];
                      this.grandTotalVerifiedCount = response.data.ds.grand_total[0]["verified_count"];
                      this.grandTotalActiveMember = response.data.ds.grand_total[0]["active_member"];
                      this.grandTotalFtdCount = response.data.ds.grand_total[0]["ftd_count"];
                      this.grandTotalFtdAmount = response.data.ds.grand_total[0]["ftd_amount"];
                      this.grandTotalUniqueLoginCount = response.data.ds.grand_total[0]["unique_login_count"];
                      this.grandTotalUniqueWithdrawalCount = response.data.ds.grand_total[0]["unique_withdrawal_count"];
                      this.grandTotalSecondDepositCount = response.data.ds.grand_total[0]["second_deposit_count"];
                    }

                    this.statementList = response.data.ds.statement;
                    this.grandTotalList = response.data.ds.grand_total;
                    this.totalRow = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.statementList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.statementList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalDepositAmount = 0
      this.grandTotalDepositAmount = 0
      this.subTotalDepositCount = 0
      this.grandTotalDepositCount = 0
      this.subTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalAmount = 0
      this.subTotalWithdrawalCount = 0
      this.grandTotalWithdrawalCount = 0
      this.subTotalBonusAmount = 0
      this.grandTotalBonusAmount = 0
      this.subTotalAdjustmentAmount = 0
      this.grandTotalAdjustmentAmount = 0
      this.subTotalRefereeCount = 0
      this.grandTotalRefereeCount = 0
      this.subTotalSignupCount = 0
      this.grandTotalSignupCount = 0
      this.subTotalVerifiedCount = 0
      this.grandTotalVerifiedCount = 0
      this.subTotalActiveMember = 0
      this.grandTotalActiveMember = 0
      this.subTotalFtdCount = 0
      this.grandTotalFtdCount = 0
      this.subTotalFtdAmount = 0
      this.grandTotalFtdAmount = 0
      this.subTotalUniqueLoginCount = 0,
      this.grandTotalUniqueLoginCount = 0,
      this.subTotalUniqueWithdrawalCount = 0,
      this.grandTotalUniqueWithdrawalCount = 0,
      this.subTotalSecondDepositCount = 0,
      this.grandTotalSecondDepositCount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>